import React from "react";
import { Reveal, SectionLabel } from "./primitives";
import { supportSteps } from "../data/content";

export const SupportTimeline = () => (
  <section
    id="support-timeline"
    aria-labelledby="support-heading"
    className="bg-brand-navy py-16 text-white lg:py-24"
  >
    <div className="mx-auto max-w-content px-4 lg:px-8">
      <Reveal className="max-w-2xl">
        <SectionLabel className="text-brand-teal">How we help</SectionLabel>
        <h2
          id="support-heading"
          className="mt-3 font-heading text-3xl font-bold tracking-tight text-white lg:text-4xl"
        >
          Support throughout your IVA
        </h2>
        <p className="mt-3 text-lg leading-relaxed text-white/75">
          It starts with us listening. Tell us where you stand and we’ll help you understand
          whether an IVA is the right way forward — then we’re with you at every stage, right
          through to completion.
        </p>
      </Reveal>

      <ol className="mt-12 grid gap-6 sm:grid-cols-2 lg:grid-cols-3 xl:grid-cols-5">
        {supportSteps.map((s, i) => (
          <Reveal
            key={s.step}
            delay={i * 0.08}
            as="li"
            className="relative rounded-2xl border border-white/10 bg-white/[0.04] p-6"
          >
            <span className="font-heading text-4xl font-bold text-brand-teal">{s.step}</span>
            <h3 className="mt-4 font-heading text-lg font-bold text-white">{s.title}</h3>
            <p className="mt-2 text-base leading-relaxed text-white/75">{s.body}</p>
          </Reveal>
        ))}
      </ol>
    </div>
  </section>
);
